export function parseIndicatorSource(value){
    const match=/^indicator:([^:]+):(\d+)$/.exec(typeof value==='string'?value:'');
    if(!match)return null;
    try{return {id:decodeURIComponent(match[1]),column:Number(match[2])};}catch{return null;}
}
export const indicatorSourceValue=(id,column)=>`indicator:${encodeURIComponent(id)}:${column}`;
export function orderIndicatorScripts(map,selection=Object.keys(map)){
    const selected=new Set(selection),ordered=[],done=new Set(),visiting=new Set(),cycles=new Set();
    function visit(id){
        if(done.has(id)||!selected.has(id))return;
        if(visiting.has(id)){for(const node of visiting)cycles.add(node);return;}
        visiting.add(id);const parent=parseIndicatorSource(map[id]?.sett?.source)?.id;
        if(parent)visit(parent);
        visiting.delete(id);done.add(id);ordered.push(id);
    }
    for(const id of selection)visit(id);
    return {ordered,cycles};
}
export function sourceDependents(map,changed){
    const result=new Set(changed);let added=true;
    while(added){added=false;for(const [id,script] of Object.entries(map))if(!result.has(id)&&result.has(parseIndicatorSource(script.sett?.source)?.id)){result.add(id);added=true;}}
    return [...result];
}
